// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import "./styles.scss"; // Import global styles
// import reportWebVitals from "./reportWebVitals";
// import { initGA, logPageView } from "./analytics";
// import App from "./App";
// import { BrowserRouter as Router, useLocation } from "react-router-dom";

// initGA("G-Y037YBXQX6");

// const Root = () => {
//   const location = useLocation();

//   React.useEffect(() => {
//     logPageView();
//   }, [location]);

//   return <App />; 
// };

// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );

// root.render(
//   <Router>
//     <Root />
//   </Router>
// );

// reportWebVitals();




import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from "react-router-dom";
import Hotjar from './constants/Hotjar';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Hotjar />
        <App />
        <ToastContainer />
      </PersistGate>
    </Provider>
  </BrowserRouter>

);

